import React from 'react';
import { Col, Row, Text } from '@common/components';
export type ItemType = {
  label: string;
  value: string;
  valueStyle?: React.CSSProperties;
};

export function DetailList({ items }: { items: ItemType[] }) {
  return (
    <div style={{ fontSize: '15px', marginTop: '16px' }}>
      {items.map((item, index) => (
        <Row
          gutter={[0, 8]}
          key={index}
          style={{ marginBottom: index === items.length - 1 ? 0 : 12 }}
        >
          <Col span={5}>
            <Text secondary>{item.label}</Text>
          </Col>
          <Col span={16} style={item.valueStyle}>
            {item.value}
          </Col>
        </Row>
      ))}
    </div>
  );
}
